import styled from "styled-components"

import { displayFont, mobileBreakpoint, tabletBreakpoint, textGrey } from "./shared"

// the white card shared by the claim form and the submitted-success view
export const ClaimCard = styled.form`
  flex: 0 0 440px;
  width: 100%;
  max-width: 440px;
  min-width: 0;
  padding: 28px;
  box-sizing: border-box;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 40px rgb(15 23 42 / 8%);

  h2 {
    font-family: ${displayFont};
    font-size: 1.25rem;
  }

  > p {
    margin: 6px 0 20px;
    color: ${textGrey};
    font-size: 0.8125rem;
  }

  /* the shared input reserves 50px right padding for the password eye icon; no field here has one */
  input {
    padding-right: 12px !important;
  }

  @media only screen and (width <= ${tabletBreakpoint}) {
    flex-basis: auto;
    max-width: 100%;
  }

  @media only screen and (width <= ${mobileBreakpoint}) {
    padding: 20px;
  }
`
